(function ($) {
    $(document).ready(function () {
        $('.button-link.button-arrow').append(`<i data-feather="arrow-right"></i>`);
        feather.replace();
    });
})(jQuery);
